import {IComponentController, IComponentOptions} from "angular";
import {Customer} from "../../customers/model/Customer";

export class CustomerListComponent implements IComponentController {

    public static instance: IComponentOptions = {
        template: require('./customer.list.component.html'),
        controller: [CustomerListComponent],
        bindings: {
            customers: '<',
            query: '<'
        }
    };
    private customers: Customer[];

    $onChanges(onChangesObj: angular.IOnChangesObject): void {
        let change = onChangesObj['customers'];
        if (change != null && !change.isFirstChange()) {
            this.customers = change.currentValue;
        }
    }


}